import React from "react";
import { useTranslation } from "react-i18next";

import styles from "../Login.module.css";

const LoginHeader = () => {
	const { t } = useTranslation("accountsPage");

	return (
		<header className={styles.header}>
			<h1 className={styles.title}>{t("login.title")}</h1>
			<p className={styles.subtitle}>{t("login.subtitle")}</p>
		</header>
	);
};

export default LoginHeader;
